// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as FaArrowLeft from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import * as FaArrowRight from "@fortawesome/free-solid-svg-icons/faArrowRight";

var buttons = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.display("flex")]);

var button = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.rem(2)),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.rem(2)),
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.white),
      BsCssJs$PrezzeeRibbon.justifyItems("center"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.transitionProperty("box-shadow"),
      BsCssJs$PrezzeeRibbon.transitionDuration(300),
      BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
      BsCssJs$PrezzeeRibbon.boxShadow(Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.px(0), BsCssJs$PrezzeeRibbon.px(20), BsCssJs$PrezzeeRibbon.px(25), BsCssJs$PrezzeeRibbon.px(-5), undefined, BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, {
                    NAME: "percent",
                    VAL: 4.0
                  }))),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.primaryRed),
      BsCssJs$PrezzeeRibbon.borderWidth("zero"),
      BsCssJs$PrezzeeRibbon.cursor("pointer"),
      BsCssJs$PrezzeeRibbon.selector("&:focus", [BsCssJs$PrezzeeRibbon.outlineWidth("zero")]),
      BsCssJs$PrezzeeRibbon.selector("&:hover", [BsCssJs$PrezzeeRibbon.boxShadow(Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.px(0), BsCssJs$PrezzeeRibbon.px(4), BsCssJs$PrezzeeRibbon.px(6), BsCssJs$PrezzeeRibbon.px(-1), undefined, BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, {
                          NAME: "percent",
                          VAL: 6.0
                        })))])
    ]);

var buttonPrev = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.rem(0.75))]);

var buttonNext = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.rem(0.75))]);

var Styles = {
  buttons: buttons,
  button: button,
  buttonPrev: buttonPrev,
  buttonNext: buttonNext
};

function BoardOfDirectorsCarousel__Arrows(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("button", {
                            children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                  icon: FaArrowLeft.faArrowLeft
                                }),
                            className: Classnames([
                                  props.prevArrowClass,
                                  button,
                                  buttonPrev
                                ]),
                            onClick: (function (e) {
                                e.preventDefault();
                              })
                          }),
                      JsxRuntime.jsx("button", {
                            children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                  icon: FaArrowRight.faArrowRight
                                }),
                            className: Classnames([
                                  props.nextArrowClass,
                                  button,
                                  buttonNext
                                ]),
                            onClick: (function (e) {
                                e.preventDefault();
                              })
                          })
                    ],
                    className: buttons
                  }),
              className: className$1
            });
}

var make = BoardOfDirectorsCarousel__Arrows;

export {
  Styles ,
  make ,
}
/* buttons Not a pure module */
